/**
 * 生成設定が使う識別子の発行と正規化。
 *
 * PowerPoint が発行する ID は、どれも設定の鍵に使えないことを実測で確かめた
 * （docs/notes/設計ノート/2026-08-31 設計ノート アドイン 生成設定の識別子.md）。要点は 3 つ。
 *
 * - `Shape.creationId` は「その図形が最初に作られたときの身元」で、実体ごとの鍵ではない。
 *   スライドを複製すると複製先へ同じ値が引き継がれる。本番フォーマット 88 枚では既に
 *   68 個の値が重複しており、最悪の 1 つは 67 箇所が同じ値を名乗っていた。
 * - `Shape.id`（cNvPr id）はスライド内でのみ一意。
 * - `Slide.id` は 1 ファイル内では一意だが、別ファイルへコピーすると同じ値が持ち込まれる。
 *
 * そこでアドインが自前で発行し、`Slide.tags` / `Shape.tags` へ書く。タグは利用者から
 * 見えず、`ppt/tags/tagN.xml` として保存され、読み戻せる。複製で値が引き継がれる点は
 * creationId と同じだが、**タグは書き込めるので衝突を検知して振り直せる**。
 */

/** スライドに振る識別子のタグ名。 */
export const SLIDE_UID_TAG = "IM_SLIDE_UID";

/** 図形に振る識別子のタグ名。 */
export const ELEMENT_UID_TAG = "IM_ELEMENT_UID";

/**
 * 新しい識別子を作る。
 *
 * `crypto.randomUUID` は WebView2 でも使えるが、`target: es5` の型に無いため
 * 直接は呼べない。乱数 16 進を 2 本つなぐ形で足りる（衝突検知が後段にあるため、
 * 暗号強度は要らない）。
 */
export function createUid(prefix: "s" | "e"): string {
    const a = Math.random().toString(16).slice(2, 10);
    const b = Math.random().toString(16).slice(2, 10);
    const t = Date.now().toString(36);
    return `${prefix}-${t}-${a}${b}`;
}
